/**
 * Flashcard là cách chơi show lên các kí hiệu ngón tay. Và nhập kết quả đọc được vào
 */

import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {FLASH_CARD_TYPE} from "../../components/flash-card-container/flash-card-container";

/**
 * Generated class for the FingerFlashCardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-finger-flash-card',
    templateUrl: 'finger-flash-card.html',
})
export class FingerFlashCardPage {

    public flashCardType = FLASH_CARD_TYPE.FINGER;

    options = {
        disabled: {},
        number_of_numbers: 1
    };

    constructor(public navCtrl: NavController, public navParams: NavParams) {
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad FingerFlashCardPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/finger-flash-card/finger-flash-card.ts